module.exports = __webpack_public_path__ + "media/images/vp/slider.index.perepis-1d00fd728e3253074fd91e98f6f3ae7a.jpg";